// The consumer's optional region between the header and the toolbar, such as a
// scope control or a legend. It stays in normal page flow, never pins with the
// table header, and takes no role or landmark of its own. Without one, nothing
// renders and no space is reserved.

import React from 'react'

import { useTable } from '../context'

export const ConsumerRegion = () => {
  const { consumerRegion } = useTable()
  if (
    consumerRegion === undefined ||
    consumerRegion === null ||
    consumerRegion === false
  )
    return null
  return <div className="me-table-consumer-region">{consumerRegion}</div>
}
